import React from 'react';
import { useAuth0 } from "@auth0/auth0-react";

function Party({ currLang }) {
  const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();
  return (
    <div style={{ padding: '4rem', maxWidth: '800px', margin: '0 auto' }}>
      <h1>{currLang === "IS" ? "PARTY!" : "PARTY!"}</h1>

      <p>{currLang === "IS" ?
        "Vó, þér hefur greinilega verið boðið í giftingar partýið okkar! Þú lukkunnar pamfíll!"
        :
        "Wow, you have obviously been invited to our wedding party! You lucky duck!"}
      </p>

      <p>{currLang === "IS" ? "Til þess að sjá nýjustu fréttir, nánari upplýsingar um gistimöguleika eða melda mætingu í veisluna þarftu að byrja á því að skrá þig inn.\n" +
        "Við viljum biðja ykkur um að vinsamlegast skrá svör ykkar við RSVP spurningarlistanum eins fljótt og auðið er, en í síðasta lagi fyrir þann 15. mars 2026.\n" +
        "Athugið, hægt er að breyta svörum ykkar fram að þeim tíma ef skoðanir breytast."
        :
        "To see the latest news, more information about accomodation options or to RSVP to the party you need to start by signing up.\n" +
        "We kindly ask you to please submit your responses to the RSVP form as soon as possible, but no later than March 15th, 2026.\n" +
        "Note that it is possible to change your responses up until that date if opinions change."}
      </p>

      <h3>{currLang === "IS" ? "Hvernig skrái ég mig inn?" : "How do I sign up?"}</h3>
      <p>{currLang === "IS" ?
        "Þú skalt búa til aðgang að síðunni okkar með því að ýta á hnappinn hér að neðan. " +
        "Þegar það er klárt ætti vefsíðan að spyrja þig um fullt nafn, það er svo við vitum hver á hvaða tölvupóstfang (og svo við vitum að óprúttnir aðilar séu ekki búnir að skrá sig)."
        :
        "You should create an account on our website by clicking the button below. " +
        "The website should then ask you for your full name, so we know who is using which email address (and so we know that no shady people have signed up)."}
      </p>
      <p>{currLang === "IS" ?
        "Þegar þú átt orðið aðgang að síðunni getur þú skoðað myndir úr athöfninni með því að smella á \"Myndir\" hnappinn efst á síðunni, eða smella á "
        :
        "When you have made your account, you can view pictures from the ceremony by clicking the \"Gallery\" button at the top of the page, or by clicking "}
        <a href="/gallery" style={{ color: 'green', borderColor: 'black' }}>{currLang === "IS" ? "þennan hlekk" : "this link"}</a>.
      </p>
      <p style={{ fontStyle: 'italic', fontSize: '0.9rem' }}>
        {currLang === "IS" ? " Vinsamlegast ekki deila myndunum eða upplýsingum sem eru inná þessari heimasíðu án þess að spyrja Ásbjörn og Magneu um leyfi." : "Please do not share the pictures or information found on this website without asking Ásbjörn and Magnea for permission."}
      </p>

      <br />
      <div>
        {isAuthenticated ? (
          <div>
            <h4>{currLang === "IS" ? "EURIKA!" : "EURIKA!"}</h4>
            <p>{currLang === "IS" ? "Þú ert með aðgang með tölvupóstinum: " : "You are signed up with the email: "} <em style={{ fontWeight: 'bold', fontStyle: 'italic' }}>{user.email}</em></p>
            <p>{currLang === "IS" ? "Ef allt hefur gengið að óskum ættir þú að fá sjálfvirkan tölvupóst frá síðunni sem þakkar þér fyrir skráninguna." : "If everything went well then you should recieve an email from the website thanking you for the signup."}</p>
            <p>{currLang === "IS" ? "Vinsamlegast kíktu í rusl möppuna þína ef þú sérð ekki tölvupóstinn." : "Please check your spam folder if you can not see the email."}</p>
            <br />
            <button className="login-button" style={{ color: 'black', borderColor: 'black' }} onClick={() => { window.location.href = '/rsvp'; }}>{currLang === "IS" ? "Fara á RSVP síðu" : "Go to RSVP"}</button>
          </div>
        ) : (
          <button className="login-button" style={{ color: 'black', borderColor: 'black' }} onClick={() => { loginWithRedirect({ appState: { returnTo: window.location.pathname } }); }}>{currLang === "IS" ? "Skrá inn" : "Login"}</button>
        )}
      </div>
      <br />
      <p>{currLang === "IS" ? "Ef þig vantar aðstoð við skráninguna eða hefur almennar spurningar, ekki hika við að hafa samband við Ásbjörn eða Magneu með einhverju móti." : "If you are in need of assistance with the signup or have some questions, do not hesitate to contact Ásbjörn or Magnea by some means."}</p>

    </div>
  );
}

export default Party;
